export const CALCULATION_MODE = {
    'single': 'single',
    'rate': 'rate'
}
